module.exports = "<div class=\"triangle\"></div>\n<ng-content></ng-content>\n"